import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export enum AihListType {
    Normal,
    NormalCan,
    HblInfo
}

export class AiHblListItem extends SearchModelBase {
    id: number = 0;
    closed: string = '';
    shipmentType: string = '';
    invStat: string = '';
    billStat: string = '';
    crDbStat: string = '';
    hawbNo: string = '';
    branch: string = '';
    refNo: string = '';
    custFName: string = '';
    custSName: string = '';
    credit: string = '';
    agentName: string = '';
    mawbNo: string = '';
    cargoNo: string = '';
    soNo: string = '';
    projectNo: string = '';
    shipmentId: string = '';
    sMawbNo: string = '';
    eta: string | null = null;
    fromETA: string | null = null;
    toETA: string | null = null;
    feta: string | null = null;
    fromFETA: string | null = null;
    toFETA: string | null = null;
    finalDest: string = '';
    shipper: string = '';
    shipperName: string | null = null;
    consignee: string = '';
    consigneeName: string | null = null;
    notify: string = '';
    notifyName: string | null = null;
    broker: string = '';
    p: string = '';
    paidDate: string | null = null;
    fromPaidDate: string | null = null;
    toPaidDate: string | null = null;
    commodity: string = '';
    incoTerms: string = '';
    pkgs: number|null = null;
    fromPkgs: number|null = null;
    toPkgs: number|null = null;
    lbs: number|null = null;
    fromLbs: number|null = null;
    toLbs: number|null = null;
    kgs: number|null = null;
    fromKgs: number|null = null;
    toKgs: number|null = null;
    operator: string = '';
    custRefNo: string = '';
    lCode: string = '';
    dCode: string = '';
    fltNo: string = '';
    finalWhse: string = '';
    releaseBy: string = '';
    releaseDate: string | null = null;
    fromReleaseDate: string | null = null;
    toReleaseDate: string | null = null;
    poNumber: string = '';
    hawbRcvdDate: string | null = null;
    fromHawbRcvdDate: string | null = null;
    toHawbRcvdDate: string | null = null;
    hawbRcvdUser: string = '';
    plRcvdDate: string | null = null;
    fromPLRcvdDate: string | null = null;
    toPLRcvdDate: string | null = null;
    plRcvdUser: string = '';
    cDocRcvdDate: string | null = null;
    fromCDocRcvdDate: string | null = null;
    toCDocRcvdDate: string | null = null;
    cDocRcvdUser: string = '';
    eDocSentDate: string | null = null;
    fromEDocSentDate: string | null = null;
    toEDocSentDate: string | null = null;
    eDocSentUser: string = '';
    etaCfrmDate: string | null = null;
    fromETACfrmDate: string | null = null;
    toETACfrmDate: string | null = null;
    etaCfrmUser: string = '';
    amsCfrmDate: string | null = null;
    fromAMSCfrmDate: string | null = null;
    toAMSCfrmDate: string | null = null;
    amsCfrmUser: string = '';
    lastTrackedDate: string | null = null;
    fromLastTrackedDate: string | null = null;
    toLastTrackedDate: string | null = null;
    lastTrackedUser: string = '';
    _7501RcvdDate: string | null = null;
    from_7501RcvdDate: string | null = null;
    to_7501RcvdDate: string | null = null;
    _7501RcvdUser: string = '';
    _3461RcvdDate: string | null = null;
    from_3461RcvdDate: string | null = null;
    to_3461RcvdDate: string | null = null;
    _3461RcvdUser: string = '';
    diSchdDate: string | null = null;
    fromDISchdDate: string | null = null;
    toDISchdDate: string | null = null;
    diSchdUser: string = '';
    actDeliveryDate: string | null = null;
    fromActDeliveryDate: string | null = null;
    toActDeliveryDate: string | null = null;
    actDeliveryUser: string = '';
    podRcvdDate: string | null = null;
    fromPODRcvdDate: string | null = null;
    toPODRcvdDate: string | null = null;
    podRcvdUser: string = '';
    billingCmpIdDate: string | null = null;
    fromBillingCmpIdDate: string | null = null;
    toBillingCmpIdDate: string | null = null;
    billingCmpIdUser: string = '';
    mailDate: string | null = null;
    fromMailDate: string | null = null;
    toMailDate: string | null = null;
    mailUser: string = '';
    postDate: string | null = null;
    fromPostDate: string | null = null;
    toPostDate: string | null = null;
    aiMblId: number = 0;
    confirmDate: string | null = null;
    fromConfirmDate: string | null = null;
    toConfirmDate: string | null = null;
    etd: string | null = null;
    itNo: string = '';
    issuer: string = '';
    recognized: string = '';
    status: string = '';
    createdAt: string|null = null;
    pimsLinkId: number = 0;

    // cloud
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    gKgs: number = 0;
    fromGKgs: number|null = null;
    toGkgs: number|null = null;
    carrierName: string = '';
    u1ID: string = '';
    u2ID: string = '';
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    split: boolean = false;
    smanID: string = '';
    anSent: boolean = false;
    atmeSent: boolean = false;
    anSentDate: string | null = null;
    fromanSentDate: string | null = null;
    toanSentDate: string | null = null;
    anSentBy: string = '';
    entryDocDate: string | null = null;
    fromentryDocDate: string | null = null;
    toentryDocDate: string | null = null;
    entryDocBy: string = '';
    delActDate: string | null = null;
    fromdelActDate: string | null = null;
    todelActDate: string | null = null;
    delActBy: string = '';
    emptyRetDate: string | null = null;
    fromemptyRetDate: string | null = null;
    toemptyRetDate: string | null = null;
    emptyRetBy: string = '';
    releaseDateForMilestoneAihList: string | null = null; //same data with releasedate
    fromReleaseDateForMilestoneAihList: string | null = null;
    toReleaseDateForMilestoneAihList: string | null = null;

    // Field is returned from server but it's not in model
    customer: number = 0;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'R', width: 30, dataIndex: 'recognized', noNullOrEmptySearch: true, hiddenInColumnSetup: true}),
        XCol.Create({ col: 38, text: 'D/ID', width: 35, dataIndex: 'shipmentType', noNullOrEmptySearch: true}),
        
        XCol.Create({ col: 3, text: 'HAWB', width: 100, dataIndex: 'hawbNo'}),
        XCol.Create({ col: 4, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 5, text: 'Ref. #', width: 100, dataIndex: 'refNo', defaultColumnFocus : true}),
        XCol.Create({ col: 6, text: 'Customer', width: 120, dataIndex: 'custSName'}),
        XCol.Create({ col: 7, text: 'Credit', width: 60, dataIndex: 'credit', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 8, text: 'A/N', width: 50, dataIndex: 'anSent', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 9, text: 'Agent', width: 120, dataIndex: 'agentName'}),
        XCol.Create({ col: 10, text: 'MAWB', width: 100, dataIndex: 'mawbNo'}),
        XCol.Create({ col: 11, text: 'S/O', width: 80, dataIndex: 'soNo'}),
        XCol.Create({ col: 12, text: 'Project ID', width: 80, dataIndex: 'projectNo'}),
        XCol.Create({ col: 13, text: 'Sub MAWB', width: 100, dataIndex: 'sMawbNo', visible: false}),
        // XCol.Create({ col: 15, text: 'ATME', width: 50, dataIndex: 'atmeSent', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 14, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 15, text: 'F. ETA', width: 75, dataIndex: 'feta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 16, text: 'Final Destination', width: 120, dataIndex: 'finalDest'}),
        XCol.Create({ col: 17, text: 'Shipper', width: 120, dataIndex: 'shipperName', hasCustomTooltip:true}),
        XCol.Create({ col: 18, text: 'Consignee', width: 120, dataIndex: 'consigneeName', hasCustomTooltip:true}),
        XCol.Create({ col: 19, text: 'Notify', width: 120, dataIndex: 'notifyName', hasCustomTooltip:true}),
        XCol.Create({ col: 20, text: 'Broker', width: 120, dataIndex: 'broker'}),
        XCol.Create({ col: 21, text: 'Issuer', width: 80, dataIndex: 'issuer'}),
        XCol.Create({ col: 22, text: 'P', width: 40, dataIndex: 'p', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 23, text: 'Paid', width: 75, dataIndex: 'paidDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 24, text: 'Commodity', width: 120, dataIndex: 'commodity'}),
        XCol.Create({ col: 25, text: 'PKG(s)', width: 80, dataIndex: 'pkgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 26, text: 'LBS', width: 80, dataIndex: 'lbs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}),
        XCol.Create({ col: 27, text: 'KGS', width: 80, dataIndex: 'kgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}),
        XCol.Create({ col: 28, text: 'Sales', width: 80, dataIndex: 'smanID'}),
        XCol.Create({ col: 29, text: 'Prep. By', width: 80, dataIndex: 'operator'}),
        XCol.Create({ col: 30, text: 'Customer Ref.', width: 100, dataIndex: 'custRefNo'}),
        XCol.Create({ col: 31, text: 'Departure', width: 80, dataIndex: 'lCode', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 32, text: 'Destination', width: 80, dataIndex: 'dCode', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 33, text: 'Flight', width: 60, dataIndex: 'fltNo'}),
        XCol.Create({ col: 34, text: 'Final W/H', width: 120, dataIndex: 'finalWhse'}),
        XCol.Create({ col: 35, text: 'Release To', width: 100, dataIndex: 'releaseBy'}),
        XCol.Create({ col: 36, text: 'Release', width: 75, dataIndex: 'releaseDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        // XCol.Create({ col: 43, text: 'Incoterms', width: 80, dataIndex: 'incoTerms', visible: true}),
        // XCol.Create({ col: 31, text: 'Carrier', width: 120, dataIndex: 'carrierName'}),
        
        XCol.Create({ col: 39, text: 'INV', width: 35, dataIndex: 'invStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 40, text: 'BIL', width: 35, dataIndex: 'billStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 41, text: 'CrDb', width: 35, dataIndex: 'crDbStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        
        //same showMilestone Check
        XCol.Create({ col: 44, text: 'Tracker', width: 75, dataIndex: 'lastTrackedUser'}),
        XCol.Create({ col: 45, text: 'Last Tracked', width: 75, dataIndex: 'lastTrackedDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 46, text: 'Send A/N', width: 75, dataIndex: 'anSentDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 47, text: 'RCV HAWB', width: 75, dataIndex: 'hawbRcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 48, text: 'RCV P/L', width: 75, dataIndex: 'plRcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 49, text: 'Rcv C. Doc', width: 75, dataIndex: 'cDocRcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 50, text: 'Send ATME', width: 75, dataIndex: 'entryDocDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 51, text: 'CFM AMS', width: 75, dataIndex: 'amsCfrmDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 52, text: 'Rcv 7501', width: 75, dataIndex: '_7501RcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 53, text: 'Rcv 3461', width: 75, dataIndex: '_3461RcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 54, text: 'Cfm ETD', width: 75, dataIndex: 'delActDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 55, text: 'CFM ATA', width: 75, dataIndex: 'emptyRetDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 56, text: 'Cargo Release', width: 75, dataIndex: 'releaseDateForMilestoneAihList', type: XCol.XCellType.Date, align: XCol.XAlignType.Center,}),
        XCol.Create({ col: 57, text: 'RCV POD', width: 75, dataIndex: 'podRcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 58, text: 'Billing CPLT', width: 75, dataIndex: 'billingCmpIdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        
        XCol.Create({ col: 59, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false}),
        XCol.Create({ col: 60, text: 'Create by', width: 100, dataIndex: 'u1ID', visible: false}),
        XCol.Create({ col: 61, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false}),
        XCol.Create({ col: 62, text: 'Update by', width: 100, dataIndex: 'u2ID', visible: false}),
        //for use tooltip
        XCol.Create({ col: 63, text: '', width: 0, dataIndex: 'shipper', hiddenInColumnSetup: true, visible: false}), 
        XCol.Create({ col: 64, text: '', width: 0, dataIndex: 'consignee', hiddenInColumnSetup: true, visible: false}),
        XCol.Create({ col: 64, text: '', width: 0, dataIndex: 'notify', hiddenInColumnSetup: true, visible: false}),
        ];

    private static ExportCollection_Can: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'R', width: 30, dataIndex: 'recognized', noNullOrEmptySearch: true, hiddenInColumnSetup: true}),
        XCol.Create({ col: 37, text: 'D/ID', width: 35, dataIndex: 'shipmentType', noNullOrEmptySearch: true}),
        
        XCol.Create({ col: 2, text: 'HAWB', width: 100, dataIndex: 'hawbNo'}),
        XCol.Create({ col: 3, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Ref. #', width: 100, dataIndex: 'refNo', defaultColumnFocus : true}),
        XCol.Create({ col: 5, text: 'Customer', width: 120, dataIndex: 'custSName'}),
        XCol.Create({ col: 6, text: 'Credit', width: 60, dataIndex: 'credit', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 7, text: 'A/N', width: 50, dataIndex: 'anSent', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 8, text: 'Agent', width: 120, dataIndex: 'agentName'}),
        XCol.Create({ col: 9, text: 'MAWB', width: 100, dataIndex: 'mawbNo'}),
        XCol.Create({ col: 10, text: 'S/O', width: 80, dataIndex: 'soNo'}),
        XCol.Create({ col: 11, text: 'Project ID', width: 80, dataIndex: 'projectNo'}),
        XCol.Create({ col: 12, text: 'Sub MAWB', width: 100, dataIndex: 'sMawbNo', visible: false}),
        //XCol.Create({ col: 15, text: 'ATME', width: 50, dataIndex: 'atmeSent', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 13, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 14, text: 'F. ETA', width: 75, dataIndex: 'feta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 15, text: 'Final Destination', width: 120, dataIndex: 'finalDest'}),
        XCol.Create({ col: 16, text: 'Shipper', width: 120, dataIndex: 'shipperName', hasCustomTooltip:true}),
        XCol.Create({ col: 17, text: 'Consignee', width: 120, dataIndex: 'consigneeName', hasCustomTooltip:true}),
        XCol.Create({ col: 18, text: 'Notify', width: 120, dataIndex: 'notifyName', hasCustomTooltip:true}),
        XCol.Create({ col: 19, text: 'Broker', width: 120, dataIndex: 'broker'}),
        XCol.Create({ col: 20, text: 'Issuer', width: 80, dataIndex: 'issuer'}),
        XCol.Create({ col: 21, text: 'P', width: 40, dataIndex: 'p', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 22, text: 'Paid', width: 75, dataIndex: 'paidDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 23, text: 'Commodity', width: 120, dataIndex: 'commodity'}),
        XCol.Create({ col: 24, text: 'PKG(s)', width: 80, dataIndex: 'pkgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 25, text: 'LBS', width: 80, dataIndex: 'lbs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}),
        XCol.Create({ col: 26, text: 'KGS', width: 80, dataIndex: 'kgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}),
        XCol.Create({ col: 27, text: 'Sales', width: 80, dataIndex: 'smanID'}),
        XCol.Create({ col: 28, text: 'Prep. By', width: 80, dataIndex: 'operator'}),
        XCol.Create({ col: 29, text: 'Customer Ref.', width: 100, dataIndex: 'custRefNo'}),
        XCol.Create({ col: 30, text: 'Departure', width: 80, dataIndex: 'lCode', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 31, text: 'Destination', width: 80, dataIndex: 'dCode', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 32, text: 'Flight', width: 60, dataIndex: 'fltNo'}),
        XCol.Create({ col: 33, text: 'Final W/H', width: 120, dataIndex: 'finalWhse'}),
        XCol.Create({ col: 34, text: 'Release To', width: 100, dataIndex: 'releaseBy'}),
        XCol.Create({ col: 35, text: 'Release', width: 75, dataIndex: 'releaseDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        // XCol.Create({ col: 43, text: 'Incoterms', width: 80, dataIndex: 'incoTerms'}),
        // XCol.Create({ col: 31, text: 'Carrier', width: 120, dataIndex: 'carrierName'}),
        
        XCol.Create({ col: 38, text: 'INV', width: 35, dataIndex: 'invStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 39, text: 'BIL', width: 35, dataIndex: 'billStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 40, text: 'CrDb', width: 35, dataIndex: 'crDbStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        
        //same showMilestone Check
        XCol.Create({ col: 43, text: 'Tracker', width: 75, dataIndex: 'lastTrackedUser'}),
        XCol.Create({ col: 44, text: 'Last Tracked', width: 75, dataIndex: 'lastTrackedDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 45, text: 'Send A/N', width: 75, dataIndex: 'anSentDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 46, text: 'RCV HAWB', width: 75, dataIndex: 'hawbRcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 47, text: 'RCV P/L', width: 75, dataIndex: 'plRcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 48, text: 'Rcv C. Doc', width: 75, dataIndex: 'cDocRcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 49, text: 'Send ATME', width: 75, dataIndex: 'entryDocDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 50, text: 'CFM AMS', width: 75, dataIndex: 'amsCfrmDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 51, text: 'Rcv 7501', width: 75, dataIndex: '_7501RcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 52, text: 'Rcv 3461', width: 75, dataIndex: '_3461RcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 53, text: 'Cfm ETD', width: 75, dataIndex: 'delActDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 54, text: 'CFM ATA', width: 75, dataIndex: 'emptyRetDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 55, text: 'Cargo Release', width: 75, dataIndex: 'releaseDateForMilestoneAihList', type: XCol.XCellType.Date, align: XCol.XAlignType.Center,}),
        XCol.Create({ col: 56, text: 'RCV POD', width: 75, dataIndex: 'podRcvdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 57, text: 'Billing CPLT', width: 75, dataIndex: 'billingCmpIdDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        
        XCol.Create({ col: 58, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false}),
        XCol.Create({ col: 59, text: 'Create by', width: 100, dataIndex: 'u1ID', visible: false}),
        XCol.Create({ col: 60, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false}),
        XCol.Create({ col: 61, text: 'Update by', width: 100, dataIndex: 'u2ID', visible: false}),
        
        //for use tooltip
        XCol.Create({ col: 62, text: '', width: 0, dataIndex: 'shipper', hiddenInColumnSetup: true, visible: false}), 
        XCol.Create({ col: 63, text: '', width: 0, dataIndex: 'consignee', hiddenInColumnSetup: true, visible: false}),
        XCol.Create({ col: 64, text: '', width: 0, dataIndex: 'notify', hiddenInColumnSetup: true, visible: false}),        
    ];

    public static getExportCollection(ltype:AihListType, useBranch: boolean): XCol.XExportColumn[] {
        if(ltype === AihListType.NormalCan) return this.ExportCollection_Can;

        const expCollection = _.cloneDeep(this.ExportCollection);
        let showInfo = false;
        switch(ltype) {
            case AihListType.Normal:
                showInfo = false;
                break;
            case AihListType.HblInfo:
                showInfo = true;
                break;
            default:
                return [];
        }

        const infoCols = [
            'lastTrackedUser',
            'lastTrackedDate',
            'anSentDate',
            'hawbRcvdDate',
            'plRcvdDate',
            'cDocRcvdDate',
            'entryDocDate',
            'amsCfrmDate',
            '_7501RcvdDate',
            '_3461RcvdDate',
            'delActDate',
            'emptyRetDate',
            'releaseDateForMilestoneAihList',
            'podRcvdDate',
            'billingCmpIdDate',
        ];

        let returnCloumns = showInfo
            ? expCollection
            : expCollection.filter(x => !infoCols.includes(x.dataIndex));
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');

        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: AiHblListItem.prototype.createdAt, orderByAscending: false };

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        eta: {from: 'fromETA', to: 'toETA'},
        feta: {from: 'fromFETA', to: 'toFETA'},
        paidDate: {from: 'fromPaidDate', to: 'toPaidDate'},
        pkgs: {from: 'fromPkgs', to: 'toPkgs'},
        lbs: {from: 'fromLbs', to: 'toLbs'},
        kgs: {from: 'fromKgs', to: 'toKgs'},
        releaseDate: {from: 'fromReleaseDate', to: 'toReleaseDate'},
        releaseDateForMilestoneAihList: {from: 'fromReleaseDateForMilestoneAihList', to: 'toReleaseDateForMilestoneAihList'},
        hawbRcvdDate: {from: 'fromHawbRcvdDate', to: 'toHawbRcvdDate'},
        plRcvdDate: {from: 'fromPLRcvdDate', to: 'toPLRcvdDate'},
        cDocRcvdDate: {from: 'fromCDocRcvdDate', to: 'toCDocRcvdDate'},
        eDocSentDate: {from: 'fromEDocSentDate', to: 'toEDocSentDate'},
        etaCfrmDate: {from: 'fromETACfrmDate', to: 'toETACfrmDate'},
        amsCfrmDate: {from: 'fromAMSCfrmDate', to: 'toAMSCfrmDate'},
        lastTrackedDate: {from: 'fromLastTrackedDate', to: 'toLastTrackedDate'},
        _7501RcvdDate: {from: 'from_7501RcvdDate', to: 'to_7501RcvdDate'},
        _3461RcvdDate: {from: 'from_3461RcvdDate', to: 'to_3461RcvdDate'},
        diSchdDate: {from: 'fromDISchdDate', to: 'toDISchdDate'},
        actDeliveryDate: {from: 'fromActDeliveryDate', to: 'toActDeliveryDate'},
        podRcvdDate: {from: 'fromPODRcvdDate', to: 'toPODRcvdDate'},
        billingCmpIdDate: {from: 'fromBillingCmpIdDate', to: 'toBillingCmpIdDate'},
        mailDate: {from: 'fromMailDate', to: 'toMailDate'},
        postDate: {from: 'fromPostDate', to: 'toPostDate'},
        emptyRetDate: {from: 'fromemptyRetDate', to: 'toemptyRetDate'},
        delActDate: {from: 'fromdelActDate', to: 'todelActDate'},
        entryDocDate: {from: 'fromentryDocDate', to: 'toentryDocDate'},
        anSentDate: {from: 'fromanSentDate', to: 'toanSentDate'},
        gKgs: {from: 'fromGKgs', to: 'toGkgs'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
        confirmDate: {from: 'fromConfirmDate', to: 'toConfirmDate'},
    }

}
